module.exports = __webpack_public_path__ + "media/images/Audio-ce632e9d.png";